export class SlickTabsSLider {
  constructor() {
    this.slider = '[data-tabs-slider]';
    this.dots = 'data-tabs-slider-dots';
    this.currentSlide = 0;
    this.eventListeners()
  }
  eventListeners() {
    if(!document.querySelector(this.slider)) {
      return;
    }
    $(this.slider).slick({
      dots: false,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 3000,
      slidesToShow: 1,
      slidesToScroll: 1,
    })

    this.setActiveDots(this.currentSlide);

    $(document).on('click', `[${this.dots}]`, (e) => {
      e.preventDefault();
      var slideno = Number(e.target.getAttribute(this.dots));
      $(this.slider).slick('slickGoTo', slideno - 1);
      this.currentSlide = slideno - 1;
    });
    
    $(this.slider).on('beforeChange', (event, slideCount, currentSlide, nextSlide) => {
      this.setActiveDots(nextSlide);
      this.currentSlide = nextSlide;
    });
  }

  setActiveDots(currentElem) {
    document.querySelectorAll('[' + this.dots + ']')[this.currentSlide].classList.remove('active');
    document.querySelectorAll('[' + this.dots + ']')[currentElem].classList.add('active');
  }
}



// WEBPACK FOOTER //
// ./scripts/main-modules/slick-tabs-sLider.js